import { useTranslations } from 'next-intl';
import { availability } from 'services/cart/types';
import { v4 as uuidv4 } from 'uuid';
import { CatButton } from 'components/blocks-components';
import { AvailabilityLine } from '../availability-line';
import { AvailabilityQuantity } from '../availability-quantity';
import { ContactDealerPopover } from '../contact-dealer-popover/contact-dealer-popover';
import { LocationAddress } from 'services/location/types';

export interface ProductAvailabilityBackorderProps {
  availability?: availability[];
  storeAddress: LocationAddress;
  isCompact?: boolean;
  shouldWrap?: boolean;
}

export function ProductAvailabilityBackorder({
  availability,
  storeAddress,
  isCompact = false,
  shouldWrap = false
}: Readonly<ProductAvailabilityBackorderProps>) {
  const t = useTranslations();

  return (
    <div>
      {availability?.map(
        ({
          availabilityMessage,
          showContactDealerPopUp: isContactDealer,
          quantityAvailable
        }) => {
          const isInStock =
            availabilityMessage?.toLowerCase() ===
            t('MO_SHIP_IN_STOCK').toLowerCase(); // Extracting from message because there is no field for inStock

          return (
            <AvailabilityLine
              key={uuidv4()}
              isCompact={isCompact}
              shouldWrap={shouldWrap}
            >
              <AvailabilityQuantity
                isInStock={isInStock}
              >{`${quantityAvailable}`}</AvailabilityQuantity>
              {isContactDealer ? (
                <>
                  {isContactDealer && (
                    <ContactDealerPopover storeAddress={storeAddress}>
                      <CatButton
                        variant="inline"
                        {...(isCompact && { size: 'sm' })}
                      >
                        {availabilityMessage || t('CONTACT_YOUR_DEALER')}
                      </CatButton>
                    </ContactDealerPopover>
                  )}
                </>
              ) : (
                availabilityMessage
              )}
            </AvailabilityLine>
          );
        }
      )}
    </div>
  );
}
